module.exports = __webpack_public_path__ + "static/media/IconLock.eca11396.svg";